/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Speakers_Metrics_By_PrefixInputs */



/**
* | output |
* | --- |
* | "By: {email}" |
*
* @param {Speakers_Metrics_By_PrefixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_by_prefix = /** @type {((inputs: Speakers_Metrics_By_PrefixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_By_PrefixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`By: ${i?.email}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`By: ${i?.email}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`By: ${i?.email}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`By: ${i?.email}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`By: ${i?.email}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`By: ${i?.email}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`By: ${i?.email}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`By: ${i?.email}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`By: ${i?.email}`)
	return /** @type {LocalizedString} */ (`By: ${i?.email}`)
});